<ng-container
    [ngTemplateOutlet]="
        downtime.isDown !== undefined
            ? finishedLoadingTemplate
            : loadingTemplate
    "></ng-container>

<ng-template #finishedLoadingTemplate>
    <ng-container
        [ngTemplateOutlet]="
            downtime.isDown ? maintenanceTemplate : clarkBodyTemplate
        "></ng-container>
</ng-template>

<ng-template #clarkBodyTemplate>
    <clark-message
        [downtime]="downtime"
        [showBanner]="!!downtime.message"></clark-message>
    <clark-primary-navbar></clark-primary-navbar>
    <clark-secondary-navbar></clark-secondary-navbar>
    <router-outlet></router-outlet>
    <clark-popup *ngIf="isOldVersion" (closed)="isOldVersion = false">
        <div #popupInner class="popup-inner">
            <div class="modal-title">{{ errorMessage[0] }}</div>
            <div class="modal-text">{{ errorMessage[1] }}</div>
            <div class="btn-group center">
                <button class="button good" (activate)="reloadPage()">
                    Refresh page <i class="fas fa-sync-alt"></i>
                </button>
            </div>
        </div>
    </clark-popup>
    <clark-cookies
        [@banner]
        *ngIf="displayCookieBanner()"
        (showCookieBanner)="showCookieBanner($event)"
        (cookieAgreement)="setCookieAgreement($event)"></clark-cookies>
</ng-template>

<clark-popup
    *ngIf="displayNewslettereBanner()"
    (closed)="showSubscriptionBanner(false)">
    <div class="modal-container" #popupInner>
        <clark-subscription
            (showAgreementBanner)="
                showSubscriptionBanner($event)
            "></clark-subscription>
    </div>
</clark-popup>

<clark-chatbot-container
    *ngIf="shouldShowChatbot()"
    [isCookieBannerVisible]="displayCookieBanner()"></clark-chatbot-container>

<ng-template #loadingTemplate> Loading... </ng-template>

<ng-template #maintenanceTemplate>
    <clark-maintenance-page></clark-maintenance-page>
</ng-template>
